const initialState = {
  members_by_id: {},
  shifts: [],
  original_shifts: [],
  periods: [],
  loading: false,
  schedule_id: null,
  display_global: false,
  hide_members_with_enough_shifts_hours: false,
  count_of_hidden_members_with_enough_shifts_hours: 0,
  selected_members: [],
  current_index: 0,
  filters: {
    search_term: '',
    period_id: '0',
    sorting: 'name_asc',
  },
};

export default function memberReducer(state = initialState, action) {
    switch (action.type) {
        case "MEMBER_SET_CURRENT_SCHEDULE_ID":
            return {
                ...state,
                schedule_id: action.payload,
            };
        case "MEMBER_SET_MEMBERS": {
            const membersById = {};
            action.payload.forEach(member => {
                membersById[member.id] = member;
            });
            return {
                ...state,
                members_by_id: membersById,
            };
        }
        case "MEMBER_SET_SHIFTS":
            return {
                ...state,
                shifts: action.payload.shifts,
                original_shifts: action.payload.original_shifts || action.payload.shifts,
                loading: false,
            };
        case "MEMBER_UPDATE_MEMBER":
            return {
                ...state,
                members_by_id: {
                    ...state.members_by_id,
                    [action.payload.id]: {
                        ...state.members_by_id[action.payload.id],
                        ...action.payload.updates,
                    },
                },
            };
        case "SHIFT_ADD_MEMBER": {
            const { shiftId, member } = action.payload;
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.map(shift =>
                    shift.identifier === shiftId
                        ? { ...shift, members: [...shift.members, member] }
                        : shift
                ),
            };
        }
        case "SHIFT_ADD_MEMBERS": {
            const { shiftId, members } = action.payload;
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.map(shift =>
                    shift.identifier === shiftId
                        ? { ...shift, members: [...shift.members, ...members] }
                        : shift
                ),
            };
        }
        case "SHIFT_REMOVE_MEMBER": {
            const { shiftId, member } = action.payload;
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.map(shift => {
                    if (shift.identifier !== shiftId) return shift;
                    
                    const updatedShift = {
                        ...shift,
                        members: shift.members.filter(m => m.id !== member.id)
                    };
                    
                    // If member was preferred, add them back to preferred_members
                    if (member.was_preferred) {
                        updatedShift.preferred_members = [
                            ...(shift.preferred_members || []),
                            { id: member.id }
                        ];
                    }
                    
                    return updatedShift;
                }),
            };
        }
        case "SHIFT_TOGGLE_LEADER": {
            const { shiftId, memberId } = action.payload;
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.map(shift => {
                    if (shift.identifier !== shiftId) return shift;
                    return {
                        ...shift,
                        members: shift.members.map(m =>
                            m.id === memberId ? { ...m, leader: !m.leader } : m
                        ),
                    };
                }),
            };
        }
        case "SHIFT_ADD_SHIFT": {
            const newIndex = Math.max(0, ...state.shifts.map(shift => shift.identifier || 0)) + 1;
            const shiftWithId = {
                ...action.payload,
                identifier: action.payload.identifier || newIndex
            };
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: [...state.shifts, shiftWithId],
                current_index: newIndex,
            };
        }
        case "SHIFT_UPDATE_SHIFT":
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.map(shift =>
                    shift.identifier === action.payload.identifier ? action.payload : shift
                ),
            };
        case "SHIFT_DELETE_SHIFT":
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.filter(shift => shift.identifier !== action.payload),
            };
        case "SHIFT_CLEAR_ALL_SHIFTS":
            window.exitWarningDirty = true;
            return {
                ...state,
                shifts: state.shifts.map(shift => ({
                    ...shift,
                    members: []
                })),
            };
        case "MEMBER_SET_PERIODS":
            return {
                ...state,
                periods: action.payload,
            };
        case "MEMBER_SET_LOADING":
            return {
                ...state,
                loading: action.payload,
            };
        case "MEMBER_SET_DISPLAY_GLOBAL":
            return {
                ...state,
                display_global: action.payload,
            };
        case "MEMBER_SET_FILTER":
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        case "MEMBER_SET_FILTERS":
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                },
            };
        case "MEMBER_RESET_FILTERS":
            return {
                ...state,
                filters: initialState.filters,
            };
        case "MEMBER_SET_HIDDEN_COUNT":
            return {
                ...state,
                count_of_hidden_members_with_enough_shifts_hours: action.payload,
            };
        case "MEMBER_ADD_TO_SELECTION":
            return {
                ...state,
                selected_members: [...state.selected_members, action.payload],
            };
        case "MEMBER_REMOVE_FROM_SELECTION":
            return {
                ...state,
                selected_members: state.selected_members.filter(id => id !== action.payload),
            };
        case "MEMBER_CLEAR_SELECTION":
            return {
                ...state,
                selected_members: [],
            };
        case "MEMBER_SET_SELECTED_MEMBERS":
            return {
                ...state,
                selected_members: action.payload,
            };
        default:
            return state;
    }
}